import * as types from './actionTypes';  
import bizInsightsApi from '../api/bizInsightsApi';
import {logout} from '../helper/helper';
import { getItem } from '../utils/localStore';
import Swal from 'sweetalert2';
import { loadingRes } from './loadingActions';

export function getBizInsights(ext_id) {

  return {
    type: types.GET_BIZ_INSIGHTS, 
    ext_id
  };
}

export function getBizInsightsRes(data) {  
  return {
    type: types.GET_BIZ_INSIGHTS_RES, 
    data
  };
}

export function fetchBizInsights(ext_id) {
  const TOKEN = getItem('auth_token');

  if(TOKEN){
    return function(dispatch) {
      dispatch(loadingRes(true));
      bizInsightsApi.getBizInsights(ext_id).then(data => {
        dispatch(getBizInsightsRes(data));
        dispatch(loadingRes(false));
        if(data.error){
          Swal.fire({
            title: data.message,
            icon: 'error',
            confirmButtonText: 'OK',
            allowOutsideClick: false,
            timer: 3000,
            heightAuto: false
          });
        }
      }).catch(error => {
        dispatch(loadingRes(false));
        return error
      });
    };
  }else{
    logout()
  }
  
}